import DashboardDefault from '../../../pages/dashboard'

const index = () => {
  return (
    <>
    {/* @info called default dashboard component here. */}
      <DashboardDefault /> 
    </>
  )
}

export default index